<template>
  <q-popup-proxy
    cover
    transition-show="scale"
    transition-hide="scale"
    @before-show="updateProxy"
  >
    <q-date v-model="proxyDate" :options="optionsFn" range today-btn>
      <div class="row items-center justify-end q-gutter-sm">
        <q-btn
          v-close-popup
          :label="$t('generic.text.cancel')"
          color="primary"
          flat
        />
        <q-btn
          v-close-popup
          :label="$t('generic.text.confirm')"
          color="primary"
          flat
          @click="save"
        />
      </div>
    </q-date>
  </q-popup-proxy>
</template>

<script>
export default {
  props: {
    date: {
      type: Object,
      default: () => ({
        from: new Date(),
        to: new Date(),
      }),
    },
  },
  emits: ['updateDate'],
  data() {
    return {
      proxyDate: {
        from: this.$moment().format('YYYY/MM/DD'),
        to: this.$moment().add(1, 'days').format('YYYY/MM/DD'),
      },
    };
  },
  methods: {
    updateProxy() {
      this.proxyDate = this.date;
    },
    optionsFn(date) {
      return date >= this.$moment().format('YYYY/MM/DD');
    },
    save() {
      if (this.proxyDate.from && this.proxyDate.to) {
        // pass
      } else {
        this.proxyDate = {
          from: this.$moment().format('YYYY/MM/DD'),
          to: this.$moment().add(1, 'days').format('YYYY/MM/DD'),
        };
      }
      this.$emit('updateDate', this.proxyDate);
    },
  },
};
</script>
